import { useFormikContext } from 'formik'

import { Associations } from 'src/components/associations'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { useStepsSelection } from 'src/hooks'
import { AssociationsType, IImpactForm } from 'src/types'

interface IProps {
  isDisabled?: boolean
}

const StepsAssociationInput = ({ isDisabled }: IProps) => {
  const { values, setFieldValue } = useFormikContext<IImpactForm>()
  const setSelectedSteps = (ids: string[]) => {
    setFieldValue('selectedSteps', ids)
  }

  const { handleSelectedStep, selectedStepsIcons } = useStepsSelection(
    values.selectedSteps,
    setSelectedSteps,
  )

  return (
    <Associations
      disabled={isDisabled}
      type={AssociationsType.STEPS}
      description={
        <HelperWrapper
          t="steps-association-title"
          isColorInherited
          size={11}
          verticalPosition={15}
        />
      }
      selectedItems={values.selectedSteps}
      handleSelectItem={handleSelectedStep}
      selectedIcons={selectedStepsIcons}
      setSelectedItems={setSelectedSteps}
      isRound
    />
  )
}

export { StepsAssociationInput }
